<template lang="pug">
.main__wrapper(:style='props.beforeAfterImageUrls' :id="`wrapperEl-${props.prefix}`")
  .main__after-box(:id="`imageEl-${props.prefix}`")
    .main__slider(:id="`sliderEl-${props.prefix}`")
</template>

<script setup>
const props = defineProps({
  beforeAfterImageUrls: {
    type: Object,
    default: () => { },
  },
  prefix: {
    type: String,
    default: '',
  },
})

const isDragged = ref(false)
const xInit = ref(0)
const x = ref(0)
const rightEl = ref(0)
const rightElMountInit = ref(0)
const rightElInit = ref(0)

const trackCoursor = (e, el) => {
  x.value = e.clientX
  const diffX = xInit.value - x.value

  if (!rightElInit.value) {
    rightEl.value = diffX <= 0 ? diffX : 0
  } else {
    rightEl.value = (diffX + rightElInit.value) <= 0 ? (diffX + rightElInit.value) : 0
  }

  el.style.right = `${rightEl.value}px`
}

const getInitRightEl = (el) => {
  const domRect = el.getBoundingClientRect()
  rightElMountInit.value = domRect.right
}

const setupPull = (sliderEl, imgEl, wrapperEl) => {
  sliderEl.onmousedown = (e) => {
    isDragged.value = true
    sliderEl.style.cursor = 'grabbing'
    xInit.value = e.clientX

    const domRect = imgEl.getBoundingClientRect()
    const right = domRect.right

    rightElInit.value = (rightElMountInit.value < right) ? (rightElMountInit.value - right) : 0
  }

  sliderEl.onmouseup = (e) => {
    isDragged.value = false
    sliderEl.style.cursor = 'grab'
  }

  wrapperEl.onmouseup = (e) => {
    isDragged.value = false
    sliderEl.style.cursor = 'grab'
  }

  wrapperEl.onmousemove = (e) => {
    if (isDragged.value && imgEl) {
      trackCoursor(e, imgEl)
    }
  }
}

function onTouch(e) {
  if (e.touches.length > 1 || (e.type === "touchend" && e.touches.length > 0))
    return

  const theTouch = e.changedTouches[0]
  console.log('touch', e)
  let mouseEv

  switch (e.type) {
    case "touchstart":
      mouseEv = "mousedown"
      break
    case "touchend":
      mouseEv = "mouseup"
      break
    case "touchmove":
      mouseEv = "mousemove"
      break
    default: return
  }

  const options = {
    view: window,
    bubbles: true,
    cancelable: true,
    detail: 1,
    screenX: theTouch.screenX,
    screenY: theTouch.screenY,
    clientX: theTouch.clientX,
    clientY: theTouch.clientY,
  }

  const mEvent = new MouseEvent(mouseEv, options)
  theTouch.target.dispatchEvent(mEvent)
}

onMounted(() => {
  const imgEl = document.querySelector(`#imageEl-${props.prefix}`)
  const sliderEl = document.querySelector(`#sliderEl-${props.prefix}`)
  const wrapperEl = document.querySelector(`#wrapperEl-${props.prefix}`)
  setupPull(sliderEl, imgEl, wrapperEl)
  getInitRightEl(imgEl)

  document.addEventListener("touchstart", onTouch, true)
  document.addEventListener("touchmove", onTouch, true)
  document.addEventListener("touchend", onTouch, true)
})

onBeforeUnmount(() => {
  document.removeEventListener('touchstart', onTouch, true)
  document.removeEventListener('touchmove', onTouch, true)
  document.removeEventListener('touchend', onTouch, true)
})
</script>

<style lang='scss' scoped>
.main {
  &__wrapper {
    --radius: 12px;
    --line-width: 4px;
    --slider-width: 40px;

    width: 100%;
    aspect-ratio: 2.3;
    max-height: 505px;
    min-height: 212px;
    background-image: var(--before-url);
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    overflow: hidden;
    border: 1px solid var(--medium-grey-color);

    @media (--mobile-viewport-df) {
      --radius: 10px;

      aspect-ratio: 1.58;
      background-image: var(--before-min-url);
    }
  }

  &__after-box {
    width: 50%;
    height: 100%;
    position: absolute;
    right: 0px;
    background-image: var(--after-url);
    background-size: cover;
    background-repeat: no-repeat;

    @media (--mobile-viewport-df) {
      aspect-ratio: 1.1;
      background-image: var(--after-min-url);
    }
  }

  &__slider {
    position: absolute;
    top: 0;
    bottom: 0;
    left: -20px;
    width: 40px;

    &::before {
      content: '';
      position: absolute;
      left: calc(var(--slider-width) / 2 - var(--line-width) / 2);
      width: var(--line-width);
      height: 100%;
      z-index: 100;
      background-color: var(--color-main);
    }

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      left: calc(var(--slider-width) / 2 - var(--radius));
      width: calc(var(--radius) * 2);
      height: calc(var(--radius) * 2);
      border-radius: 50%;
      background-color: var(--color-main);
      z-index: 100;
    }

    &:hover {
      cursor: grab;
    }
  }

  &__after {
    height: 505px;
    position: absolute;
    right: 0;
  }
}
</style>
